<script>
import VideoPlayer from "../../component/VideoPlayer.vue";
import { mapState } from "vuex";
export default {
  name: "rocket",
  components: {
    VideoPlayer,
  },
  data() {
    return {
      smokeURL: require("../../assets/images/smoke.png"),
      player: null,
    };
  },
  computed: {
    ...mapState({
      rockettime: (state) => state.space.rockettime,
    }),
  },
  mounted() {
    let smokeImg = new Image();
    smokeImg.src = this.smokeURL;
    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    window.onYouTubeIframeAPIReady = () => {
      this.player = new window.YT.Player("player", {
        videoId: window.g.YOUTUBE_VIDEO_ID,
        suggestedQuality: "hd1080",
        playerVars: {
          playsinline: 1,
          showinfo: 0,
          controls: 0,
          fs: false,
          iv_load_policy: 3,
        },
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onPlayerStateChange,
        },
      });
    };
  },
  methods: {
    startVideo() {
      this.player.setPlaybackQuality("hd1080");
      // let today = this.formatDate(new Date(), "-");
      // let goplay = 0;
      // if (Date.now() >= new Date(`${today} 19:38:00`).getTime()) {
      //   let sec = Math.floor(
      //     Math.abs(
      //       new Date().getTime() - new Date(`${today} 19:38:00`).getTime()
      //     ) / 1000
      //   );
      //   goplay = sec + 3 || 0;
      // }
      // this.player.seekTo(goplay, true);
      // if (goplay < 120) {
      this.player.mute().playVideo();
      // }
    },
    stopVideo() {
      this.player.stopVideo();
    },
    onPlayerReady() {
      this.startVideo();
    },
    onPlayerStateChange(event) {
      if (event.data === window.YT.PlayerState.ENDED && this.rockettime > 2) {
        this.$store.dispatch("space/updateRockettime", {
          rockettime: 4,
        });
      }
    },
    getDateb(date) {
      let dateb;
      if (typeof date === "string") {
        dateb = date.match(
          new RegExp(
            "(\\d{4})-(\\d{2})-?(\\d{2})?\u0020?(\\d{2})?:?(\\d{2})?:?(\\d{2})?",
            "g"
          )
        );
        dateb = dateb ? dateb.join("").split("-").join("/") : "";
        date = date.split("-").join("/");
      }
      return dateb || date;
    },
    formatDate(date, sp) {
      let enddate = this.getDateb(date);
      let spStr = sp || ".";
      let dateYear = new Date(enddate).getFullYear();
      let dateMonth = (new Date(enddate).getMonth() + 1)
        .toString()
        .padStart(2, "0");
      let dateDate = new Date(enddate).getDate().toString().padStart(2, "0");
      return `${dateYear}${spStr}${dateMonth}${spStr}${dateDate}`;
    },
  },
};
</script>

<!-- 引入template.html,style.scss  -->
<template src="./template.html"></template>
<style lang="scss" src="./style.scss"></style>
